<template>
    <div :key="componentKey" class="betgameEditSpecialQuestionDetail" id="betgameEditSpecialQuestionDetail">
      
      <NavigationBar>
          <template v-slot:left>
              <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack">
          </template>
          <template v-slot:center>
            {{ $t('betgame_settings.edit_special_question') }}
          </template>
          <template v-slot:right>
          </template>
      </NavigationBar>
  
      <div v-if="isCreateState && !this.isBattle() && !this.isTeamsBetgame()" class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_select_teamplate_or_create_own') }}
        </div>
        <div v-if="isWM2022()" class="input-element">
          <select id="select_question" v-model="selectedQuestion" @change="questionSelectedWM2022($event)">
            <option disabled value="" hidden>{{ $t('betgame_settings.edit_special_question_select_teamplate') }}:</option>
            <option v-for="q in teamtipQuestionsWM2022" :value="q.id">{{ q.question }}</option>
          </select>
        </div>
        <div v-else-if="isWM2023()" class="input-element">
          <select id="select_question" v-model="selectedQuestion" @change="questionSelectedWM2023($event)">
            <option disabled value="" hidden>{{ $t('betgame_settings.edit_special_question_select_teamplate') }}:</option>
            <option v-for="q in teamtipQuestionsWM2023" :value="q.id">{{ q.question }}</option>
          </select>
        </div>
        <div v-else-if="isFootball()" class="input-element">
          <select id="select_question" v-model="selectedQuestion" @change="questionSelectedNFL($event)">
            <option disabled value="" hidden>{{ $t('betgame_settings.edit_special_question_select_teamplate') }}:</option>
            <option v-for="q in teamtipQuestionsNFL" :value="q.id">{{ q.question }}</option>
          </select>
        </div>
        <div v-else-if="isDarts()" class="input-element">
          <select id="select_question" v-model="selectedQuestion" @change="questionSelectedDarts($event)">
            <option disabled value="" hidden>{{ $t('betgame_settings.edit_special_question_select_teamplate') }}:</option>
            <option v-for="q in teamtipQuestionsDarts" :value="q.id">{{ q.question }}</option>
          </select>
        </div>
        <div v-else class="input-element">
          <select id="select_question" v-model="selectedQuestion" @change="questionSelected($event)">
            <option disabled value="" hidden>{{ $t('betgame_settings.edit_special_question_select_teamplate') }}:</option>
            <option v-for="q in teamtipQuestions" :value="q.id">{{ q.question }}</option>
          </select>
        </div>
      </div>
      
      <div class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_text_label') }}
        </div>
        <div class="input-element">
          <input type="text" v-model="questionText" name="nickname_old" id="question" placeholder="Fragestellung" value />
          <label for="question">{{ $t('betgame_settings.edit_special_question_text_placeholder') }}</label>
        </div>
      </div>

      <div class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_solution_type_label') }}
        </div>
        <div class="input-radio">
          <input v-on:change="questionTypeChanged" type="radio" id="team" name="answertype" v-model="questionType" v-bind:value="'TEAM'" />
          <label v-if="this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id !== 2346" for="team">{{ $t('betgame_settings.edit_special_question_solution_type_team') }}</label>
          <label v-else for="team">{{ $t('betgame_settings.edit_special_question_solution_type_player') }}</label>
        </div>
        <!--
        <div class="input-radio">
          <input type="radio" id="player" name="answertype" value="2" />
          <label for="player">Spieler</label>
        </div>
        -->
        <div class="input-radio">
          <input v-on:change="questionTypeChanged" type="radio" id="bool" name="answertype" v-model="questionType" v-bind:value="'BOOL'" />
          <label for="bool">{{ $t('betgame_settings.edit_special_question_solution_type_yes_no') }}</label>
        </div>
        <div class="input-radio">
          <input v-on:change="questionTypeChanged" type="radio" id="number" name="answertype" v-model="questionType" v-bind:value="'NUMBER'" />
          <label for="number">{{ $t('betgame_settings.edit_special_question_solution_type_number') }}</label>
        </div>
      </div>
  
      <div v-if="questionType === 'TEAM'" class="input-container">
        <div v-if="this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id !== 2346" class="input-header">
          {{ $t('betgame_settings.edit_special_question_solution_type_team') }}
        </div>
        <div v-else class="input-header">
          {{ $t('betgame_settings.edit_special_question_solution_type_player') }}
        </div>
        <div v-if="this.$store.state.betgame.type === 1 && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id !== 2346" class="input-empty" style="margin-bottom: 20px; color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_solution_type_team_description') }}
        </div>
        <div v-else-if="this.$store.state.betgame.type === 1 && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 2346" class="input-empty" style="margin-bottom: 20px; color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_solution_type_player_description') }}
        </div>
        <div v-else-if="this.$store.state.betgame.type === 2" class="input-empty" style="margin-bottom: 20px; color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_solution_type_team_description_battle') }}
        </div>
        <div v-else-if="this.$store.state.betgame.type === 3" class="input-empty" style="margin-bottom: 20px; color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_solution_type_team_description_team') }}
        </div>
      </div>
      <div v-else-if="questionType === 'BOOL'" class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_solution_type_yes_no') }}
        </div>
        <div class="input-empty" style="margin-bottom: 20px; color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_solution_type_yes_no_description') }}
        </div>
      </div>
      <div v-else-if="questionType === 'NUMBER'" class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_solution_type_number') }}
        </div>
        <div class="input-empty" style="color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_solution_type_number_description') }}
        </div>
        <div class="input-stepper">
          <div @click="minNumberUp" class="input-stepper-button input-stepper-button-up"></div>
          <input id="minNumberUp" min="0" v-model.number="minNumber" style="width: 80px;"
                 step="1" placeholder="-" type="number">
          <div @click="minNumberDown" class="input-stepper-button input-stepper-button-down"></div>
          <label for="minNumberUp">{{ $t('betgame_settings.edit_special_question_solution_type_number_min') }}</label>
        </div>
        <div class="input-stepper">
          <div @click="maxNumberUp" class="input-stepper-button input-stepper-button-up"></div>
          <input id="maxNumberUp" min="0" v-model.number="maxNumber" style="width: 80px;"
                 step="1" placeholder="-" type="number">
          <div @click="maxNumberDown" class="input-stepper-button input-stepper-button-down"></div>
          <label for="maxNumberUp">{{ $t('betgame_settings.edit_special_question_solution_type_number_max') }}</label>
        </div>
      </div>
      
      <div class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_points_per_correct_answer') }}
        </div>
        <div class="input-stepper">
          <div @click="pointsUp" class="input-stepper-button input-stepper-button-up"></div>
          <input id="points1" max="99" min="1" v-model.number="points"
                 step="1" placeholder="-" type="number">
          <div @click="pointsDown" class="input-stepper-button input-stepper-button-down"></div>
          <label for="points1">{{ $t('points') }}</label>
        </div>
        
        <!-- Die Abfrage nach der Anzahl der Punkte pro Antwort soll nur angezeigt werden, wenn in der Liste "Antwort(en)" mehr als eine Antwort ausgewählt wurde
        <div class="input-infotext">
          Soll die Anzahl der Punkte für jede richtige Antwortmöglichkeit gelten?
        </div>
        <div class="input-radio">
          <input type="radio" id="yes" name="points" value="1" />
          <label for="yes">Ja</label>
        </div>
        <div class="input-radio">
          <input type="radio" id="no" name="points" value="2" />
          <label for="no">Nein</label>
        </div>
        -->
      </div>

      <div class="list">
        <div class="table-view-title">
          {{ $t('betgame_settings.edit_special_question_enter_answer_until') }}
        </div>
        <div class="input-empty" style="color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_editable_until_description_1') }}
        </div>
        <div class="input-empty" style="color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_editable_until_description_2') }}
        </div>
        <div class="table-view-cell" style="margin-bottom: 16px; margin-top: 16px;">
          <datetime v-model="editableUntil" type="datetime" :min-datetime="new Date().toISOString()" :minute-step="5"></datetime>
        </div>
      </div>
      
      <div class="input-container">
        <div class="input-header">
          {{ $t('betgame_settings.edit_special_question_answer_count') }}
        </div>
        <div v-if="this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id !== 2346" class="input-empty" style="color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_answercount_description') }}
        </div>
        <div v-else-if="this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 2346" class="input-empty" style="color: #5F5D5C;">
          {{ $t('betgame_settings.edit_special_question_answercount_description_player') }}
        </div>
        <div class="input-stepper" style="border-bottom: 0">
          <div @click="answerCountUp" class="input-stepper-button input-stepper-button-up"></div>
          <input id="points2" max="99" min="1" v-model.number="answerCount"
                 step="1" placeholder="-" type="number" :disabled="answerCountDisabled">
          <div @click="answerCountDown" class="input-stepper-button input-stepper-button-down"></div>
          <label for="points2">{{ $t('betgame_settings.edit_special_question_solutions') }}</label>
        </div>
        <div v-if="!this.isCreateState && solutions.length > 0" style="font-size: 15px; color: #5F5D61;">
          <div v-if="solutions.length === 1" style="width: 100%;">
            {{ $t('betgame_settings.edit_special_question_entered_solution') }}:
          </div>
          <div v-else-if="solutions.length > 1" style="width: 100%;">
            {{ $t('betgame_settings.edit_special_question_entered_solutions') }}:
          </div>
          <div v-for="(solution, index) in solutions" style="width: 100%;">
            <div v-if="question.type === 'TEAM'" style="">
              {{ getTeamName(parseInt(solution.solution)) }}
            </div>
            <div v-else-if="question.type === 'NUMBER'">
              {{ solution.solution }}
            </div>
            <div v-else-if="question.type === 'BOOL' && '' + solution.solution === '1'">
              {{ $t('yes') }}
            </div>
            <div v-else-if="question.type === 'BOOL' && '' + solution.solution === '0'">
              {{ $t('no') }}
            </div>
          </div>
        </div>
        <div v-if="!this.isCreateState" class="input-button-row">
          <button v-if="answerCount === 1 && solutions.length === 0" v-on:click="enterSolutions({})" name="button">{{ $t('betgame_settings.edit_special_question_button_enter_solution') }}</button>
          <button v-else-if="answerCount > 1  && solutions.length === 0" v-on:click="enterSolutions({})" name="button">{{ $t('betgame_settings.edit_special_question_button_enter_solutions') }}</button>
          <button v-else-if="answerCount === 1 && solutions.length > 0" v-on:click="enterSolutions({})" name="button">{{ $t('betgame_settings.edit_special_question_button_change_solution') }}</button>
          <button v-else-if="answerCount > 1  && solutions.length > 0" v-on:click="enterSolutions({})" name="button">{{ $t('betgame_settings.edit_special_question_button_change_solutions') }}</button>
        </div>
      </div>
      
      <ul class="error-container">
        <li v-for="error in errors">{{ error }}</li>
      </ul>
      
      <button v-on:click="saveQuestion">{{ $t('button_save_text') }}</button>
      
      <button v-on:click="deleteQuestion" v-if="this.question !== undefined && this.question.id > 0 && this.question.fk_betgame === parseInt(this.$store.state.betgameId)" class="button-danger">{{ $t('button_delete_text') }}</button>

    </div>
</template>

<script>
  
  import NavigationBar from './../components/NavigationBar'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import { MATCH_DATE_FORMAT, TOAST_DURATION, TYPE_BATTLE_ID, TYPE_BETGAME_ID, TYPE_TEAMS_ID } from '../main'
  import moment from 'moment'
  import Vue from 'vue'
  
  export default {
    name: 'BetgameEditSpecialQuestionDetail',
    components: { NavigationBar, datetime: Datetime },
    data () {
      return {
        question: null,
        componentKey: 0,
        questionText: '',
        questionType: '',
        points: 1,
        answerCount: 1,
        minNumber: 0,
        maxNumber: 10,
        editableUntil: new Date(Date.now() + (1000 * 60 * 60 * 24 * 30) ).toISOString(),
        selectedQuestion: '',
        errors: []
      }
    },
    beforeCreate () {
      if(this.$store.state.specialQuestionTeams.length === 0 && parseInt(this.$store.state.betgame.type) !== TYPE_BETGAME_ID) {
        this.$store.dispatch('fetchSpecialQuestionTeams')
      }
    },
    created () {
      this.question = this.$route.params.question
      if(this.question === null || this.question === undefined) {
        this.$router.push('/betgameeditspecialquestions')
      } else {
        if(this.question.id > 0) {
          this.editableUntil = this.question.editable_until
          this.questionText = this.question.question !== undefined ? this.question.question : ''
          this.questionType = this.question.type !== undefined ? this.question.type : ''
          this.points = this.question.points !== undefined ? this.question.points : 1
          this.answerCount = this.question.answer_count !== undefined ? this.question.answer_count : 1
          this.minNumber = 0
          this.maxNumber = 10
          if(this.questionType === 'NUMBER') {
            const opt = this.question.options !== undefined ? this.question.options : ''
            if (opt !== undefined && opt.length > 0) {
              const minmax = opt.trim().split(',')
              if (minmax.length === 2) {
                const minVal = parseInt(minmax[0])
                const maxVal = parseInt(minmax[1])
                this.minNumber = minVal < maxVal ? minVal : maxVal
                this.maxNumber = minVal < maxVal ? maxVal : minVal
                if(this.maxNumber > 9999999) {
                  this.maxNumber = 9999999
                }
              }
            }
          }
        } else {
          this.editableUntil = new Date(Date.now() + (1000 * 60 * 60 * 24 * 30)).toISOString()
          this.questionText = ''
          this.questionType = ''
          this.points = 1
          this.answerCount = 1
          this.minNumber = 0
          this.maxNumber = 10
        }
        this.componentKey += 1
      }
    },
    mounted () {
      if (this.$store.state.teams.length === 0) {
        if(this.$store.state.leagueId !== undefined && this.$store.state.leagueId > 0) {
          this.$store.dispatch('fetchTeams', this.$store.state.leagueId)
        } else if(this.$store.state.betgame.competition !== undefined) {
          this.$store.dispatch('fetchTeams', this.$store.state.betgame.competition.id)
        }
      }
    },
    computed: {
      answerCountDisabled() {
        return this.questionType !== 'TEAM'
      },
      solutions() {
        if(this.$store.state.solutions && this.question) {
          const solutions = this.$store.state.solutions.filter(s => s.fk_question === this.question.id)
          if (solutions.length > 0) {
            return solutions
          }
        }
        return []
      },
      teamtipQuestions() {
        var q = [
          {"id":1,"question":this.$i18n.t('special_questions.default_special_question_empty'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,2000","fk_betgame":null,"fk_season":15},
          {"id":13,"question":this.$i18n.t('special_questions.default_special_question_1'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":15,"optionsJSON":[]}, 
          {"id":14,"question":this.$i18n.t('special_questions.default_special_question_2'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":15,"optionsJSON":[]},
          {"id":48,"question":this.$i18n.t('special_questions.default_special_question_3'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,2000","fk_betgame":null,"fk_season":15},
          {"id":49,"question":this.$i18n.t('special_questions.default_special_question_4'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,100","fk_betgame":null,"fk_season":15},
          {"id":50,"question":this.$i18n.t('special_questions.default_special_question_5'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,100","fk_betgame":null,"fk_season":15}
          ]
        /*
        var r = []
        for (var i = 0; i < this.$store.state.questions.length; i++) {
          const q = this.$store.state.questions[i]
          if (q.fk_betgame === null) {
            r.push(q)
          }
        }
        */
        return q
      },
      teamtipQuestionsWM2022() {
        var q = [
          {"id":2,"question":this.$i18n.t('special_questions.default_special_question_empty'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,2000","fk_betgame":null,"fk_season":16},
          {"id":3,"question":this.$i18n.t('special_questions.default_special_question_wm2022_1'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":4,"question":this.$i18n.t('special_questions.default_special_question_wm2022_2'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":5,"question":this.$i18n.t('special_questions.default_special_question_wm2022_3'),"type":"TEAM","points":10,"answer_count":16,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":6,"question":this.$i18n.t('special_questions.default_special_question_wm2022_4'),"type":"TEAM","points":10,"answer_count":12,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":7,"question":this.$i18n.t('special_questions.default_special_question_wm2022_5'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,300","fk_betgame":null,"fk_season":16}
        ]
        return q
      },
      teamtipQuestionsWM2023() {
        var q = [
          {"id":2,"question":this.$i18n.t('special_questions.default_special_question_empty'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,2000","fk_betgame":null,"fk_season":14},
          {"id":3,"question":this.$i18n.t('special_questions.default_special_question_wm2023_1'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":4,"question":this.$i18n.t('special_questions.default_special_question_wm2023_2'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":5,"question":this.$i18n.t('special_questions.default_special_question_wm2023_3'),"type":"TEAM","points":10,"answer_count":16,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":6,"question":this.$i18n.t('special_questions.default_special_question_wm2023_4'),"type":"TEAM","points":10,"answer_count":8,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":7,"question":this.$i18n.t('special_questions.default_special_question_wm2023_5'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,300","fk_betgame":null,"fk_season":14}
        ]
        return q
      },
      teamtipQuestionsEM2024() {
        var q = [
          {"id":2,"question":this.$i18n.t('special_questions.default_special_question_empty'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,2000","fk_betgame":null,"fk_season":14},
          {"id":3,"question":this.$i18n.t('special_questions.default_special_question_em2024_1'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":4,"question":this.$i18n.t('special_questions.default_special_question_em2024_2'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":5,"question":this.$i18n.t('special_questions.default_special_question_em2024_3'),"type":"TEAM","points":10,"answer_count":16,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":6,"question":this.$i18n.t('special_questions.default_special_question_em2024_4'),"type":"TEAM","points":10,"answer_count":6,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":14,"optionsJSON":[]},
          {"id":7,"question":this.$i18n.t('special_questions.default_special_question_em2024_5'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,300","fk_betgame":null,"fk_season":14}
        ]
        return q
      },
      teamtipQuestionsNFL() {
        var q = [
          {"id":2,"question":this.$i18n.t('special_questions.default_special_question_nfl_1'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":3,"question":this.$i18n.t('special_questions.default_special_question_nfl_2'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":4,"question":this.$i18n.t('special_questions.default_special_question_nfl_3'),"type":"TEAM","points":10,"answer_count":8,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":5,"question":this.$i18n.t('special_questions.default_special_question_nfl_4'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,100","fk_betgame":null,"fk_season":16},
          {"id":6,"question":this.$i18n.t('special_questions.default_special_question_nfl_5'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,100","fk_betgame":null,"fk_season":16},
          {"id":7,"question":this.$i18n.t('special_questions.default_special_question_nfl_6'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,200","fk_betgame":null,"fk_season":16},
          {"id":8,"question":this.$i18n.t('special_questions.default_special_question_nfl_7'),"type":"BOOL","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,1","fk_betgame":null,"fk_season":16}
        ]
        return q
      },
      teamtipQuestionsDarts() {
        var q = [
          {"id":2,"question":this.$i18n.t('special_questions.default_special_question_darts_1'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":3,"question":this.$i18n.t('special_questions.default_special_question_darts_2'),"type":"TEAM","points":10,"answer_count":4,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]},
          {"id":4,"question":this.$i18n.t('special_questions.default_special_question_darts_3'),"type":"NUMBER","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"0,100","fk_betgame":null,"fk_season":16},
          {"id":5,"question":this.$i18n.t('special_questions.default_special_question_darts_4'),"type":"BOOL","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16},
          {"id":6,"question":this.$i18n.t('special_questions.default_special_question_darts_5'),"type":"TEAM","points":10,"answer_count":1,"editable_until":"2030-01-01T08:00:00","options":"<null>","fk_betgame":null,"fk_season":16,"optionsJSON":[]}
        ]
        return q
      },
      isCreateState() {
        return this.question === undefined || this.question.id === undefined || this.question.id === null || this.question.id === 0
      }
    },
    methods: {
      questionTypeChanged() {
        this.answerCount = 1
      },
      enterSolutions() {
        if(this.question && this.question.id > 0) {
          this.$router.push({ name: 'betgameeditspecialquestionanswers', params: { question: this.question } })
        } else {
        
        }
      },
      pointsUp() {
        if(this.points < 100) {
          this.points += 1
        } else {
          this.points = 100
        }
      },
      pointsDown() {
        if(this.points > 1) {
          this.points -= 1
        }
      },
      answerCountUp() {
        if(this.answerCountDisabled) {
          return
        }
        if(this.answerCount < 32) {
          this.answerCount += 1
        } else {
          this.answerCount = 32
        }
      },
      answerCountDown() {
        if(this.answerCountDisabled) {
          return
        }
        if(this.answerCount > 1) {
          this.answerCount -= 1
        }
      },
      minNumberUp() {
        if(this.minNumber < 1000) {
          this.minNumber += 1
        } else {
          this.minNumber = 10
        }
      },
      minNumberDown() {
        if(this.minNumber > 0) {
          this.minNumber -= 1
        }
      },
      maxNumberUp() {
        if(this.maxNumber < 9999999) {
          this.maxNumber += 1
        } else {
          this.maxNumber = 10
        }
      },
      maxNumberDown() {
        if(this.maxNumber > 1) {
          this.maxNumber -= 1
        }
      },
      deleteQuestion() {
        var r = confirm(this.$i18n.t('betgame_settings.confirm_delete_special_question'));
        if (r === true) {
          this.$store.dispatch('deleteQuestion', this.question.id).then(response => {
            Vue.$log.debug('deleteQuestion ok')
            this.$toast.open({ message: this.$i18n.t('betgame_settings.delete_special_question_success'), position: 'top', duration: TOAST_DURATION, type: 'success' })
            this.$router.push('/betgameeditspecialquestions')
          }, error => {
            Vue.$log.debug('deleteQuestion error ' + error.toString())
          })
        }
      },
      saveQuestion() {
        Vue.$log.debug('saveQuestion')
        this.errors = []
        if(this.isNullOrUndefined(this.questionText) || this.questionText.length === 0) {
          this.errors.push(this.$i18n.t('betgame_settings.special_question_save_error_mssing_question'))
        }
        if(this.isNullOrUndefined(this.questionType) || this.questionType.length === 0) {
          this.errors.push(this.$i18n.t('betgame_settings.special_question_save_error_answer_type_not_selected'))
        }
        if(this.isNullOrUndefined(this.points) || this.points < 1) {
          this.errors.push(this.$i18n.t('betgame_settings.special_question_save_error_mssing_points'))
        }
        if(this.isNullOrUndefined(this.answerCount) || this.answerCount < 1) {
          this.errors.push(this.$i18n.t('betgame_settings.special_question_save_error_mssing_answer_count'))
        }
        if(this.isNullOrUndefined(this.answerCount) || this.answerCount > 32) {
          this.errors.push(this.$i18n.t('betgame_settings.special_question_save_error_max_answer_count'))
        }
        if(this.isNullOrUndefined(this.editableUntil) || (new Date().toISOString() > this.editableUntil) && this.solutions.length === 0) {
          this.errors.push(this.$i18n.t('betgame_settings.special_question_save_error_mssing_editable_util_date'))
        }
        Vue.$log.debug('editableUntil ' + this.question.id + ' --- ' + this.editableUntil)
        Vue.$log.debug('editableUntil ' + moment(this.editableUntil))
        Vue.$log.debug('momformat ' + moment(this.editableUntil).format('YYYY-MM-DD HH:mm:ss'))
        if (this.errors.length === 0) {
          var options = this.question.options
          if(this.questionType === 'NUMBER') {
            if(this.maxNumber > 9999999) {
              this.maxNumber = 9999999
            }
            options = this.maxNumber > this.minNumber ? '' + this.minNumber + ',' + this.maxNumber :
                    '' + this.maxNumber + ',' + this.minNumber
          } else if(this.questionType === 'TEAM') {
            if(this.$store.state.betgame.type === TYPE_BETGAME_ID) {
              const teams = this.$store.state.teams
              var result = []
              if (teams.length > 0) {
                for (var i = 0; i < teams.length; i++) {
                  const team = teams[i]
                  if(team.is_placeholder && parseInt(team.is_placeholder) === 1) {
                    continue
                  }
                  const n = this.$store.state.language === 'de' ? team.name : team.name_int
                  result.push({ id: team.id, name: n })
                }
              }
              options = JSON.stringify(result)
            } else if(this.$store.state.betgame.type === TYPE_BATTLE_ID || this.$store.state.betgame.type === TYPE_TEAMS_ID) {
              const teams = this.$store.state.specialQuestionTeams
              var result = []
              if (teams.length > 0) {
                for (var i = 0; i < teams.length; i++) {
                  const team = teams[i]
                  const n = this.$store.state.language === 'de' ? team.name : team.name_int
                  result.push({ id: team.id, name: n })
                }
              }
              options = JSON.stringify(result)
              /*
              var temp = []
              var result = []
              for(var i = 0; i <  this.$store.state.matches.length; i++) {
                const match = this.$store.state.matches[i]
                if(match.fk_team_home !== undefined) {
                  if(!temp.includes(match.fk_team_home)) {
                    const t1 = this.$store.state.teams.filter(t => t.id === match.fk_team_home)
                    if(t1.length === 1) {
                      const name = this.$store.state.language === 'de' ? t1[0].name : t1[0].name_int
                      result.push({ id: match.fk_team_home, name: name })
                      temp.push(match.fk_team_home)
                    }
                  }
                }
                if(match.fk_team_guest !== undefined) {
                  if(!temp.includes(match.fk_team_guest)) {
                    const t1 = this.$store.state.teams.filter(t => t.id === match.fk_team_guest)
                    if(t1.length === 1) {
                      const name = this.$store.state.language === 'de' ? t1[0].name : t1[0].name_int
                      result.push({ id: match.fk_team_guest, name: name })
                      temp.push(match.fk_team_guest)
                    }
                  }
                }
              }
              options = JSON.stringify(result)
              */
            } 
          } else if(this.questionType === 'BOOL') {
            options = '0,1'
          }
          if(this.question.id > 0) {
            Vue.$log.debug('patch 1')
            const updatequestion = {
              'id': this.question.id,
              'question': this.questionText,
              'type': this.questionType,
              'points': parseInt(this.points),
              'answer_count': parseInt(this.answerCount),
              'editable_until': moment(this.editableUntil).format('YYYY-MM-DD HH:mm:ss'),
              'options': options
            }
            /*
            this.question.question = this.questionText
            this.question.type = this.questionType
            this.question.points = parseInt(this.points)
            this.question.answer_count = parseInt(this.answerCount)
            this.question.editable_until = moment(this.editableUntil).format('YYYY-MM-DD HH:mm:ss')
            */
            Vue.$log.debug('patch ' + JSON.stringify(updatequestion))
            this.$store.dispatch('patchQuestion', updatequestion).then(response => {
              Vue.$log.debug('patchQuestion ok')
              this.$toast.open({ message: this.$i18n.t('betgame_settings.save_special_question_success'), position: 'top', duration: TOAST_DURATION, type: 'success' })
            }, error => {
              Vue.$log.debug('patchQuestion error ' + error.toString())
            })
          } else {
            const insertquestion = {
              'question': this.questionText,
              'type': this.questionType,
              'points': parseInt(this.points),
              'answer_count': parseInt(this.answerCount),
              'fk_betgame': parseInt(this.$store.state.betgameId),
              'fk_season': parseInt(this.$store.state.betgame.season.id),
              'editable_until': moment(this.editableUntil).format('YYYY-MM-DD HH:mm:ss'),
              'options': options
            }
            Vue.$log.debug('postQuestion ' + JSON.stringify(insertquestion))
            this.$store.dispatch('postQuestion', insertquestion).then(response => {
              this.question.id = response
              Vue.$log.debug('postQuestion ok ' + JSON.stringify(response))
              this.$toast.open({ message: this.$i18n.t('betgame_settings.save_special_question_success'), position: 'top', duration: TOAST_DURATION, type: 'success' })
              this.$router.push('/betgameeditspecialquestions')
            }, error => {
              Vue.$log.debug('postQuestion error ' + error.toString())
            })
          }
        }
      },
      questionSelected(event) {
        const temp = this.teamtipQuestions.filter(q => '' + q.id === '' + event.target.value)
        if (temp.length === 1 && temp[0].id > 1) {
          this.questionText = temp[0].question
          this.questionType = temp[0].type
          this.points = temp[0].points
          this.answerCount = temp[0].answer_count
          this.componentKey += 1
        }
      },
      questionSelectedWM2022(event) {
        const temp = this.teamtipQuestionsWM2022.filter(q => '' + q.id === '' + event.target.value)
        if (temp.length === 1 && temp[0].id > 1) {
          this.questionText = temp[0].question
          this.questionType = temp[0].type
          this.points = temp[0].points
          this.answerCount = temp[0].answer_count
          this.componentKey += 1
        }
      },
      questionSelectedWM2023(event) {
        const temp = this.teamtipQuestionsWM2023.filter(q => '' + q.id === '' + event.target.value)
        if (temp.length === 1 && temp[0].id > 1) {
          this.questionText = temp[0].question
          this.questionType = temp[0].type
          this.points = temp[0].points
          this.answerCount = temp[0].answer_count
          this.componentKey += 1
        }
      },
      questionSelectedEM2024(event) {
        const temp = this.teamtipQuestionsEM2024.filter(q => '' + q.id === '' + event.target.value)
        if (temp.length === 1 && temp[0].id > 1) {
          this.questionText = temp[0].question
          this.questionType = temp[0].type
          this.points = temp[0].points
          this.answerCount = temp[0].answer_count
          this.componentKey += 1
        }
      },
      questionSelectedNFL(event) {
        const temp = this.teamtipQuestionsNFL.filter(q => '' + q.id === '' + event.target.value)
        if (temp.length === 1 && temp[0].id > 1) {
          this.questionText = temp[0].question
          this.questionType = temp[0].type
          this.points = temp[0].points
          this.answerCount = temp[0].answer_count
          this.componentKey += 1
        }
      },
      questionSelectedDarts(event) {
        const temp = this.teamtipQuestionsDarts.filter(q => '' + q.id === '' + event.target.value)
        if (temp.length === 1 && temp[0].id > 1) {
          this.questionText = temp[0].question
          this.questionType = temp[0].type
          this.points = temp[0].points
          this.answerCount = temp[0].answer_count
          this.componentKey += 1
        }
      },
      goBack () {
        this.$router.push('/betgameeditspecialquestions')
      },
    }
  }
</script>

<style lang="scss" scoped>
  
  .betgameEditSpecialQuestionDetail {
    max-width: 432px;
    margin: 0 auto auto auto;

    @media screen and (min-width: 768px) {
      margin: 48px auto 0;
    }
  }

  .list {
    position: relative;
    padding: 4px 16px;
    margin: 16px auto 0;
    max-width: 400px;
  }

  .input-container {
    margin: 16px auto 0;
  }

  button {
    margin-top: 16px;
  }

  #select_question {
    width: 100%;
    margin: 10px 0px;

  }
  
</style>
